if (!customElements.get('progress-bar')) {

  class ProgressBar extends HTMLElement {

    constructor() {
      super();

      // Options
      this.options = {
        "gift_threshold": 2500,
        "shipping_threshold": 5000,
        "currency": {
          "name": "British Pound",
          "iso_code": "GBP",
          "symbol": "£"
        },
        "translations": {
          "gift_threshold_text": "{{ html }} away from a free gift",
          "shipping_threshold_text": "{{ html }} away from free shipping",
          "reached_text": "You have reached free shipping"
        }
      }

      // Get options from element data and combine with this.options
      if (this?.dataset?.options) {
        const dataOptions = parseJson(this.dataset.options);
        this.options = {
          ...this.options,
          ...dataOptions
        };
      }

      // elements
      this.elements = {
        content: this.querySelector('[data-progress-bar-content]'),
        header: this.querySelector('[data-progress-bar-header]'),
        bar: this.querySelector('[data-progress-bar]'),
        barInner: this.querySelector('[data-progress-bar-inner]')
      }

      // Initialize progress bar state on page load
      this.initializeProgressBar();

    }

    /*
      Initialize progress bar state on page load
      Checks if thresholds are already met and hides progress bar accordingly
    */
    initializeProgressBar() {
      // Get current cart total from the page
      let currentCartTotal = 0;

      // Try to get cart total from data attribute first
      const cartTotalElement = document.querySelector('[data-cart-total]');
      if (cartTotalElement) {
        currentCartTotal = parseInt(cartTotalElement.getAttribute('data-cart-total')) || 0;
      }

      // Fallback: try to get from cart object if available
      if (currentCartTotal === 0 && typeof window.cart !== 'undefined' && window.cart.total_price) {
        currentCartTotal = window.cart.total_price;
      }

      // If we have a cart total, check if thresholds are met
      if (currentCartTotal > 0) {
        this.checkAndHideIfThresholdsMet(currentCartTotal);
      }
    }

    /*
      Check if thresholds are met and hide progress bar if they are
      @param totalPrice {number}: current cart total price
    */
    checkAndHideIfThresholdsMet(totalPrice) {
      const giftThreshold = this.options.gift_threshold || 0;
      const shippingThreshold = this.options.shipping_threshold || 0;

      // Check if both thresholds are met (or if only one is set and it's met)
      let shouldHide = false;

      if (giftThreshold > 0 && shippingThreshold > 0) {
        // Both thresholds set - hide if both are met
        shouldHide = totalPrice >= giftThreshold && totalPrice >= shippingThreshold;
      } else if (giftThreshold > 0) {
        // Only gift threshold set - hide if met
        shouldHide = totalPrice >= giftThreshold;
      } else if (shippingThreshold > 0) {
        // Only shipping threshold set - hide if met
        shouldHide = totalPrice >= shippingThreshold;
      }

      if (shouldHide) {
        this.elements.header.innerText = this.options.translations.reached_text;
        this.elements.barInner.style.width = `100%`;
        this.elements.bar.classList.add('progress-bar__bar--reached');
        this.elements.bar.classList.remove('progress-bar__bar--step-2');

        // Hide progress bar
        this.style.height = `0px`;
        this.classList.add('progress-bar--hidden');
      }
    }

    /*
      Update the progress bar
      @param state {object}: state object received from cart update (cart.js)
    */
    update(state) {

      // get total price from state
      const { total_price } = state;

      // Highest price
      let highestPrice = this.options.gift_threshold <= this.options.shipping_threshold ? this.options.shipping_threshold : this.options.gift_threshold;

      // type
      let type = 'gift';
      if (
        (!this.options.gift_threshold || total_price >= this.options.gift_threshold)
        && (!this.options.shipping_threshold || total_price >= this.options.shipping_threshold)
      ) {
        type = 'completed'
      }
      else if (!this.options?.gift_threshold) {
        type = 'shipping';
      }
      else if (this.options.gift_threshold <= this.options.shipping_threshold && total_price >= this.options.gift_threshold) {
        type = 'shipping';
      }
      else if (this.options.gift_threshold > this.options.shipping_threshold && total_price < this.options.shipping_threshold) {
        type = 'shipping';
      }

      // free gift not reached
      if (type == 'gift') {

        let price_to_go = this.options.gift_threshold - total_price,
            price_to_go_html = `${this.options.currency.symbol}${(Math.round(price_to_go) / 100).toFixed(2).replace('.00', '')}`,
            procent = Math.round((total_price * 100) / highestPrice),
            header_text = this.options.translations.gift_threshold_text.replace('{{ html }}', price_to_go_html);

        this.elements.header.innerText = header_text
        this.elements.barInner.style.width = `${procent}%`;
        this.elements.bar.classList.remove('progress-bar__bar--reached');
        if (this.options?.shipping_threshold && total_price < this.options.shipping_threshold) {
          this.elements.bar.classList.remove('progress-bar__bar--step-2');
        } else {
          this.elements.bar.classList.add('progress-bar__bar--step-2');
        }

        // Hide progress bar
        this.style.height = `${this.elements.content.offsetHeight}px`;
        this.classList.remove('progress-bar--hidden');

      }

      // free shipping not reached
      else if (type == 'shipping') {

        let price_to_go = this.options.shipping_threshold - total_price,
            price_to_go_html = `${this.options.currency.symbol}${(Math.round(price_to_go) / 100).toFixed(2).replace('.00', '')}`,
            procent = Math.round((total_price * 100) / highestPrice),
            header_text = this.options.translations.shipping_threshold_text.replace('{{ html }}', price_to_go_html);

        this.elements.header.innerText = header_text
        this.elements.barInner.style.width = `${procent}%`;
        this.elements.bar.classList.remove('progress-bar__bar--reached');
        if (this.options?.gift_threshold && total_price < this.options.gift_threshold) {
          this.elements.bar.classList.remove('progress-bar__bar--step-2');
        } else {
          this.elements.bar.classList.add('progress-bar__bar--step-2');
        }

        // Hide progress bar
        this.style.height = `${this.elements.content.offsetHeight}px`;
        this.classList.remove('progress-bar--hidden');

      }

      // free shipping and gift reached
      else {

        this.elements.header.innerText = this.options.translations.reached_text;
        this.elements.barInner.style.width = `100%`;
        this.elements.bar.classList.add('progress-bar__bar--reached');
        this.elements.bar.classList.remove('progress-bar__bar--step-2');

        // Show progress bar
        this.style.height = `0px`;
        this.classList.add('progress-bar--hidden');

      }

    }

  }

  window.ProgressBar = ProgressBar;

  customElements.define('progress-bar', ProgressBar);

}